/* Schooner Supply — native topbar sort handler.
   ============================================================
   Replaces Concept's FacetSort onChange path for the topbar
   sort, after the <facet-sort><hover-element> markup was
   swapped to a native <select class="sn-sort-select"> in
   sections/main-collection.liquid (task 72; rollback context
   in commit b1f63dc, full saga 23fc80d..b1f63dc).

   Mechanism (mirrors collection.js:391-405 exactly):
   - On `change`, build a new URL from window.location with
     ?sort_by=<value>&section_id=<id>, drop ?page=.
   - Find Concept's <form is="facet-form"> (lives in the
     in-drawer filter UI, rendered by snippets/facets.liquid).
     If absent, fall back to a full GET navigation (still
     re-sorts, just without SRA grid swap).
   - Call form.renderSection(url, event) — Concept's SRA fetch.

   Why a document-level delegated listener:
   The collection section gets replaced in-place on every SRA
   render. A listener bound to the <select> element itself
   would be discarded with the old DOM. Delegation on
   `document` survives every re-render — same lesson the
   redesign hit earlier with quick-view.
*/
(function () {
  'use strict';

  function findFacetForm(el) {
    return (el && el.closest && el.closest('form[is="facet-form"]')) ||
           document.querySelector('form[is="facet-form"]');
  }

  function sectionIdFromForm(form) {
    // Mirror theme.utils.sectionId: prefer data-section-id, fall
    // back to nearest [id^="shopify-section-"] ancestor stripped.
    if (form.dataset && form.dataset.sectionId) return form.dataset.sectionId;
    var s = form.closest('[id^="shopify-section-"]');
    return s ? s.id.replace('shopify-section-', '') : '';
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.classList || !target.classList.contains('sn-sort-select')) return;

    var value = target.value;
    if (!value) return;

    var form = findFacetForm(target);
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    url.searchParams.delete('page');

    if (form && typeof form.renderSection === 'function') {
      var sid = sectionIdFromForm(form);
      if (sid) url.searchParams.set('section_id', sid);
      try {
        form.renderSection(url.toString(), event);
        return;
      } catch (e) {
        // fall through to navigation fallback
      }
    }

    // No facet-form on the page (rare — e.g. sort enabled but
    // filtering disabled). Do a plain GET so the sort still works.
    url.searchParams.delete('section_id');
    window.location.assign(url.toString());
  });
})();
